var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0H5C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5L0 19C0 19.6566 0.129329 20.3068 0.380602 20.9134C0.631876 21.52 1.00017 22.0712 1.46447 22.5355C2.40215 23.4732 3.67392 24 5 24H19C19.6566 24 20.3068 23.8707 20.9134 23.6194C21.52 23.3681 22.0712 22.9998 22.5355 22.5355C22.9998 22.0712 23.3681 21.52 23.6194 20.9134C23.8707 20.3068 24 19.6566 24 19V5C24 4.34339 23.8707 3.69321 23.6194 3.08658C23.3681 2.47995 22.9998 1.92876 22.5355 1.46447C22.0712 1.00017 21.52 0.631876 20.9134 0.380602C20.3068 0.129329 19.6566 0 19 0V0ZM22 19C22 19.7956 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7956 22 19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7956 2 19V5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H19C19.7956 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V19Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/square.d03d5ac09cda088511ffd78314c4943c.svg";